
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 61 56","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.5 10.943L52.078 50.5H8.922L30.5 10.943zM30.5.5l-30 55h60l-30-55zM28 23h5v15h-5V23zm2.5 24.375a3.128 3.128 0 01-3.125-3.125 3.128 3.128 0 013.125-3.125c1.722 0 3.125 1.4 3.125 3.125a3.128 3.128 0 01-3.125 3.125z","fill":"#FF9800"}})])
          )
        }
      }
    